/* Built In Imports */

/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import SingleLineText from '@components/UI/SingleLineText';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import SectionTitle from '@components/uyirnokkam/UymSectionTitle';

/* Services */

/**
 * Renders the Card Circular 2 Column Group Card component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @param {string} lang - Current User Language.
 * @param {string} region - Current User Country.
 * @param sectionContent.region
 * @param sectionContent.lang
 * @returns {ReactElement} UymProgramInfo component
 */
const UymProgramInfo = ({ sectionContent, region, lang }) => {
  return (
    <Box
      background={{
        base: 'none',
        md: 'url(https://static.sadhguru.org/d/46272/1732965358-uym_bg_prog_info.png) top left no-repeat',
        "2xl": 'url(https://static.sadhguru.org/d/46272/1737039288-uym_bg_prog_info1.png) top left no-repeat'
      }}
      className='congentBg'
    >
      <Box pt={{ base: '20px', md: '45px' }} pb={{ base: '20px', md: '30px' }}>
        <SectionTitle
          titleObj={sectionContent[0]}
          lang={lang}
          titlecolor={'#ffffff'}
        />
      </Box>
      <Flex
        justifyContent={{base:'left', md:'center'}}
        alignItems="flex-start"
        flexWrap="wrap"
        px={{ base: '20px', lg: '0px' }}
        mx="auto"
        maxW={'1110px'}
        m={{base:'0 0 0 20px', md: '0 auto'}}
        pl={{base:'0', md:'0px'}}
        width={{base:'320px', md:'auto'}}
        margin={{base:'0 auto'}}
      >
        <Box width={{ base: '90%', xl: '24%' }} pl={{base:'0', md:'20px'}} mb={{ base: '30px' }}  mr={{ base:'0px' }}>
          {sectionContent[1]?.text && (
            <Box
              display="flex"
              alignItems={{base:'center', md:'flex-start'}}
              gridGap="10px"
              borderRight={{base:'none', md:'1px solid #FFFFFF30'}}
            >
              <LazyLoadImageComponent
                src="https://static.sadhguru.org/d/46272/1732968658-uym_icon_day.png"
                height="36px"
                mr={{base:'8px', md:'0px'}}
              />
              <SingleLineText
                sectionContent={sectionContent[1]}
                fontFamily={'MuktaMlalar'}
                my="0px"
                pl={{base:'5px', md:'10px'}}
                pr={{base:'0', md:'10px'}}
                fontSize={'20px'}
                color="#fff"
              />
            </Box>
          )}
        </Box>
        <Box
          width={{ base: '100%', xl: '31%' }}
          mb={{ base: '30px' }} mr={{base:'0px'}}
          pr={{ base: '', md: '10px' }}
          pl={{ base: '', md: '25px' }}
        >
          {sectionContent[2]?.text && (
            <Box
              display="flex"
              alignItems={{base:'center', md:'flex-start'}}
              gridGap="10px"
              borderRight={{base:'none', md:'1px solid #FFFFFF30'}}
            >
              <LazyLoadImageComponent
                src="https://static.sadhguru.org/d/46272/1732968658-uym_icon_time.png"
                height="36px"
                mr={{base:'8px', md:'10px'}}
              />
              <SingleLineText
                sectionContent={sectionContent[2]}
                fontFamily={'MuktaMlalar'}
                my="0px"
                color="#fff"
                fontSize={'20px'}
              />
            </Box>
          )}
        </Box>
        <Box
          pl={{ base: '0', md: '18px' }}
          width={{ base: '100%', xl: '39%' }}
          mb={{ base: '20px' }}
          mr={{ base:'0px' }}
        >
          {sectionContent[3]?.body && (
            <Box display="flex" alignItems={{base:'flex-start', md:'flex-start'}} gridGap="10px">
              <LazyLoadImageComponent
                src="https://static.sadhguru.org/d/46272/1732968658-uym_icon_venue.png"
                height="36px"
                mr={{base:'8px', md:'10px'}}
              />
              <StructuredTextParser
                str={render(sectionContent[3].body)}
                region={region}
                lang={lang}
                color="#fff"
                fontFamily={'MuktaMlalar'}
                fontSize={{ base: '18px', md: '18px' }}
                mt={'0px'}
                className="title-text"
              />
            </Box>
          )}
        </Box>
      </Flex>
      {sectionContent[4]?.text && (
        <Box textAlign={'center'} width={'100%'} pt={{ base:'10px', md:'30px'}}>
          <SingleLineText
            sectionContent={sectionContent[4]}
            fontFamily={'MuktaMlalar'}
            my="10px"
            fontSize={'16px'}
            lineHeight={'20px'}
            textAlign={'center'}
            color="#fff"
          />
        </Box>
      )}
      <style>
        {`
            @media only screen and (min-width: 1400px) {
              .congentBg {
                background-position-x: 50px
              }
            }
            .title-text h6 {
              font-size: 20px;
              line-height: 32px;
            }
          `}
      </style>
    </Box>
  );
};

export default UymProgramInfo;
